export default {
  title: 'Własne produkty drukowane',
  fields: {
    name: 'Nazwa',
    format: 'Typ produktu',
  },
  buttons: {
    upload_product: 'Rozpocznij przesyłanie',
    preview: 'Podgląd',
    edit: 'Edytuj',
  },
};
